import axios from "axios";

export function apiGetEngagements(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/engagements" +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetEngagement(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/engagements/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveEngagement(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/engagements", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateEngagement(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/engagements/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteEngagement(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/engagements/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
